// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dlvSqI85rRmbEhfAhICH li{padding:16px !important;transition:all 1s ease;border-radius:16px}`, "",{"version":3,"sources":["webpack://./src/app/common/components/list.component/style.module.scss"],"names":[],"mappings":"AACE,yBACE,uBAAA,CACA,sBAAA,CACA,kBAAA","sourcesContent":[".app-list-container {\n  li {\n    padding: 16px !important;\n    transition: all 1s ease;\n    border-radius: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"app-list-container": `dlvSqI85rRmbEhfAhICH`
};
export default ___CSS_LOADER_EXPORT___;
